"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FavoritesHeart = void 0;
var UserActionEvent = _interopRequireWildcard(require("@ori-events/user-action"));
var _react = require("react");
var _constants = require("../../constants");
var _contexts = require("../../contexts");
var _HeartIcon = require("./HeartIcon");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const renderHeart = (isInFavorites, onClick) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_HeartIcon.HeartIcon, {
  isFavorite: isInFavorites,
  onClick: onClick
});
const FavoritesHeart = ({
  code,
  productListId,
  render,
  shades
}) => {
  const {
    isProductInList,
    isProductInLists,
    onFavoritesClick,
    toggleProductInLists
  } = (0, _contexts.useFavorites)();
  const isInFavorites = (0, _react.useMemo)(() => productListId ? isProductInList({
    productCode: code,
    productListId
  }) || (shades ?? []).some(({
    productCode
  }) => isProductInList({
    productCode,
    productListId
  })) : isProductInLists(code) || (shades ?? []).some(({
    productCode
  }) => isProductInLists(productCode)), [code, isProductInList, isProductInLists, productListId, shades]);
  const handleClick = (0, _react.useCallback)(event => {
    event.preventDefault();
    event.stopPropagation();
    UserActionEvent.dispatch([isInFavorites ? _constants.ANALYTICS_FAVORITES_REMOVE : _constants.ANALYTICS_FAVORITES_ADD, window.location.pathname, code]);
    if (productListId) {
      void toggleProductInLists({
        productCode: code,
        productListIds: [productListId]
      });
    } else {
      onFavoritesClick({
        productCode: code
      });
    }
  }, [code, isInFavorites, onFavoritesClick, productListId, toggleProductInLists]);
  const rendered = render?.(renderHeart(isInFavorites), handleClick);
  return rendered ?? renderHeart(isInFavorites, handleClick);
};
exports.FavoritesHeart = FavoritesHeart;
